var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc vnode
 */
import * as lodash from '../utils/lodash';
function parseNumber(attr) {
    return parseFloat(attr);
}
function parseNumberOrPercent(attr) {
    if (attr.indexOf('%') !== -1) {
        return attr;
    }
    return parseFloat(attr);
}
function parseString(attr) {
    return attr;
}
function parseArray(attr) {
    return attr.split(/\s+/).map(function (val) { return parseFloat(val); });
}
function parseNumberOrString(attr) {
    if (isNaN(parseInt(attr, 10))) {
        return attr;
    }
    return parseInt(attr, 10);
}
function parseBoxShadow(attr) {
    var _a = attr.split(/\s+/), a = _a[0], b = _a[1], c = _a[2], shadowColor = _a[3];
    return {
        shadowOffsetX: parseFloat(a),
        shadowOffsetY: parseFloat(b),
        shadowBlur: parseFloat(c),
        shadowColor: shadowColor,
    };
}
export var NodeAttributeParser = {
    flex: parseNumber,
    align: parseString,
    pack: parseString,
    padding: parseArray,
    opacity: parseNumber,
    width: parseNumberOrPercent,
    height: parseNumberOrPercent,
    minWidth: parseNumber,
    maxWidth: parseNumber,
    minHeight: parseNumber,
    maxHeight: parseNumber,
    borderColor: parseString,
    borderWidth: parseNumber,
    background: parseString,
    borderRadius: parseArray,
    fontSize: parseNumber,
    fontFamily: parseString,
    fontWeight: parseNumberOrString,
    lineHeight: parseNumber,
    lineClamp: parseNumber,
    src: parseString,
    value: parseString,
    color: parseString,
    ellipsis: parseString,
    boxShadow: parseBoxShadow,
    cursor: parseString,
};
export var attributeList = Object.keys(NodeAttributeParser);
/**
 * vnode
 */
var VNode = /** @class */ (function () {
    function VNode(props) {
        this.parentNode = null;
        this.children = [];
        this.bbox = { x: 0, y: 0, width: 0, height: 0 };
        this.minSize = [0, 0];
        this.ownerDocument = null;
        this.props = __assign(__assign({}, this.defaultProps), props);
    }
    VNode.prototype.render = function () {
        return null;
    };
    VNode.prototype.appendChild = function (child) {
        child.parentNode = this;
        child.ownerDocument = this.ownerDocument;
        this.children.push(child);
    };
    VNode.prototype.getRoot = function () {
        var root = this;
        while (root.parentNode) {
            root = root.parentNode;
        }
        return root;
    };
    VNode.prototype.getClosestNodeProps = function (name) {
        var node = this.parentNode;
        while (node) {
            if (node.props[name] !== undefined) {
                return node.props[name];
            }
            node = node.parentNode;
        }
    };
    VNode.prototype.getExtendAttr = function (attr) {
        var value = this.getClosestNodeProps(attr);
        if (value === undefined) {
            return this.ownerDocument.conf[attr];
        }
        return value;
    };
    VNode.prototype.computeSize = function () {
        // nothing todo
    };
    VNode.prototype.layout = function () {
        // blank;
    };
    VNode.prototype.getStyle = function () {
        var _a = this.props, borderColor = _a.borderColor, borderRadius = _a.borderRadius, background = _a.background, borderWidth = _a.borderWidth;
        return {
            stroke: borderColor,
            r: borderRadius,
            fill: background,
            lineWidth: borderWidth,
        };
    };
    VNode.prototype.getEventsAndCursor = function () {
        var events = {};
        for (var key in this.props) {
            var value = this.props[key];
            if (typeof value === 'function') {
                events[key] = value;
            }
        }
        events.cursor = this.props.cursor;
        return events;
    };
    VNode.prototype.getClampSize = function (size, sizeType) {
        var minSize = this.props[sizeType === 'width' ? 'minWidth' : 'minHeight'];
        var maxSize = this.props[sizeType === 'width' ? 'maxWidth' : 'maxHeight'];
        if (lodash.isNumber(maxSize) && size > maxSize) {
            size = maxSize;
        }
        if (lodash.isNumber(minSize) && size < minSize) {
            size = minSize;
        }
        return size;
    };
    VNode.selfClosing = false;
    return VNode;
}());
export default VNode;
